import jsPDF from "jspdf";
import arabicToThai from "../../../../../hook/arabicToThai";
import oneBell from "../../../../../assets/images/license/oneBell.png";
import oneJumbo from "../../../../../assets/images/license/3.png";
import signature_sakon from "../../../../../assets/images/license/24.png";
import dayjs from "dayjs";
import CurrencyFormat from "../../../../../hook/CurrencyFormat";
import "../../../../../assets/font/THSarabunNew-normal";
import "../../../../../assets/font/THSarabunNew-bold";

export async function createPdfRePrintAcc3(data = [], selectedContract, totalCount, startOffset = 0, lawyer = "sakon") {
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  console.log("data", data);

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  data?.forEach((person, index) => {
    // let calNOPAY = (person?.NOPAY - 1)
    // let calDate = (dayjs(person?.FirstUnpaidDate).subtract(calNOPAY, "month").format("YYYY-MM-DD"))
    // console.log("calNOPAY", calNOPAY)
    // console.log("calDate", calDate)
    if (index !== 0) pdf.addPage();

    // let y = 20;
    let y = 15;
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(16);

    // ส่วนหัว
    pdf.text(`กรุณาส่ง`, 25, y);
    // y += 5;
    // y += 10;

    pdf.text(
      `${person.customerFullname} (${person.CONTNO}) (${person.customerTypeId === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.customerTypeId})`,
      40,
      y,
    );
    y += 5;

    // pdf.text(`${index + 1}/${currentBatchNumber}`, 180, y);
     pdf.text(`${startOffset + index + 1}/${totalCount}`, 180, y);

    pdf.text(person.ADDR1 ? person.ADDR1 : "-", 40, y);

    y += 5;
    pdf.text(
      `ต.${person.TUMB ? person.TUMB : "-"} อ.${
        person.AUMPDES ? person.AUMPDES : "-"
      } จ.${person.PROVDES ? person.PROVDES : "-"}`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.ZIP, 40, y);

    y += 5;
    pdf.text(person.TELP, 40, y);

    y += 5;
    pdf.text(`(${dayjs(person.datetime).format("DD/MM/YYYY")})`, 40, y);

    // y += 38;
    y += 53;
    pdf.setFontSize(14);
    pdf.text(
      `วันที่ ${dayjs(person.datetime).add(543, "year").format("D MMMM YYYY")}`,
      150,
      y,
    );
    pdf.text(`เรื่อง   บอกเลิกสัญญากู้ยืม เลขที่ (${person.CONTNO})`, 20, y);
    y += 5;
    pdf.text(
      `เรียน   ${person.BSNAM} ${person.BNAME1} ${person.BNAME2} (ผู้กู้)`,
      20,
      y,
    );

    let xLeft = 30;
    let xRight = 120;
    let yGUARANTORS = y + 5;

    // เรียง GARNO จากน้อย -> มาก (0,1,2,...)  ถ้าไม่มีค่าให้ไปท้ายสุด
    const sortedGuarantors = [...(person?.guarantor ?? [])].sort((a, b) => {
      const ga = Number(a?.garno ?? Number.POSITIVE_INFINITY);
      const gb = Number(b?.garno ?? Number.POSITIVE_INFINITY);
      return ga - gb; // asc
    });

    sortedGuarantors.forEach((g, i) => {
      const x = i % 2 === 0 ? xLeft : xRight;

      pdf.text(
        `${g.snam} ${g.name1} ${g.name2} (${
          Number(g?.garno) === 0 ? "ผู้กู้" : `ผู้ค้ำประกัน ${Number(g?.garno)}`
        })`,
        x,
        yGUARANTORS,
      );

      // ครบ 2 คนในแถวแล้วค่อยขึ้นบรรทัดใหม่
      if (i % 2 === 1) yGUARANTORS += 5;
    });

    // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
    y = yGUARANTORS + 15;
    const signDate = dayjs(person.SDATE)
      .add(543, "year")
      .format("DD MMMM YYYY");
    //   เนื้อหา
    const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
    y += 5;
    const content = [
      `${indent}ตามที่ท่านทำสัญญากู้ยืมเงินและสัญญาค้ำประกันกับ บริษัท วัน มันนี่ จำกัด ผู้ให้กู้เมื่อวันที่ ${signDate
      } เป็นเงินจำนวน ${currencyFormatPoint(person?.NCSHPRC)} บาท ตกลงผ่อนชำระต้นเงินพร้อมดอกเบี้ยตลอดอายุสัญญา จำนวน ${person?.T_NOPAY
      } งวด งวดละ 1 เดือน ชำระเดือนละ ${currencyFormatPoint(person?.TOT_UPAY)} บาท ชำระทุกวันที่ ${dayjs(person?.FirstUnpaidDate).format("D")
      } ของเดือน เริ่มชำระงวดแรกภายในวันที่ ${dayjs(person?.FDATE).add(543, "year").format("D MMMM YYYY")} และงวดสุดท้ายชำระในวันที่ ${dayjs(person?.LDATE).add(543, "year").format("D MMMM YYYY")
      } เพื่อเป็นการประกันการชำระหนี้ท่านได้มอบสมุดคู่มือจดทะเบียนรถยนต์ยี่ห้อ ${person?.TYPE ? person?.TYPE : "-"} รุ่น ${person?.MODEL ? person?.MODEL : "-"} สี ${person?.COLOR ? person?.COLOR : "-"
      } ทะเบียน ${person?.REGNO ? person?.REGNO : "-"} ${person?.DORECV ? person?.DORECV : "-"} เลขเครื่อง ${person?.ENGNO ? person?.ENGNO : "-"} เลขตัวถัง ${person?.STRNO ? person?.STRNO : "-"
      } มาเป็นหลักประกันในการ กู้ยืมเงินไว้กับทางบริษัทฯด้วย และผู้กู้ได้รับเงินกู้ครบถ้วนแล้วในวันที่ทำสัญญาโดยผู้ค้ำประกันยินยอมรับผิดหากผู้กู้ไม่ชำระหนี้ดังกล่าว`,

      `${indent}บัดนี้ปรากฏว่าผู้กู้ปฏิบัติผิดสัญญาไม่ชำระหนี้ให้แก่บริษัทฯ เป็นจำนวน ${
        person?.EXP_TO - person?.EXP_FRM
      } งวดติดต่อกัน ตั้งแต่งวดที่ ${person?.EXP_FRM} - ${person?.EXP_TO} เป็นต้นมา มีหนี้ค้างชำระเป็นเงินต้นพร้อมดอกเบี้ย จำนวน ${currencyFormatPoint(
        parseFloat(person?.EXP_AMT || 0),
      )} บาท ดังนั้นบริษัทฯผู้ให้กู้ จึงขอให้ท่านนำเงินจำนวนดังกล่าวพร้อมดอก เบี้ยปรับและค่าใช้จ่าย มาชำระให้เสร็จสิ้น ณ ที่ทำการของผู้ให้กู้ภายใน 30 วัน นับตั้งแต่ที่ท่านได้รับหรือถือว่าได้รับหนังสือฉบับนี้`,

      `${indent}หากครบกำหนดดังกล่าวข้างต้น แล้วท่านเพิกเฉยไม่ดำเนินการตามหนังสือฉบับนี้ ผู้ให้กู้ขอถือว่าหนังสือฉบับนี้เป็นหนังสือ
บอกเลิกสัญญาดังกล่าวข้างต้น หากท่านประสงค์จะส่งมอบรถยนต์ที่เป็นหลักประกันเพื่อใช้หนี้ดังกล่าวข้างต้นขอให้ส่งมอบรถยนต์
ที่ใช้เป็นหลักประกันในสภาพที่ใช้การได้ดี ภายใน 30 วัน นับตั้งแต่วันที่ท่านได้รับหนังสือฉบับนี้ หากท่านเพิกเฉยผู้ให้กู้มีความ
จำเป็นต้องดำเนินคดีกับท่านทันที และท่านยังต้องรับผิดชอบในความเสียหายอันพึงเกิดขึ้นทั้งปวงด้วย`,

      `${indent}หากท่านมีการชำระเงินจำนวนดังกล่าวเป็นที่เรียบร้อยแล้วทางผู้ให้กู้ ต้องขออภัย ณ โอกาสนี้`,
    ];

    content.forEach((line) => {
      const splitText = pdf.splitTextToSize(line, 170);
      pdf.text(splitText, 20, y);
      y += splitText.length * 6;
    });

    pdf.text(`ขอแสดงความนับถือ`, 47, y + 2); // (x, y)
    let imageWidthImg = 25; // Adjust width to fit your needs
    let imageHeightImg = 15; // Adjust height to fit your needs
    if (lawyer === "pongsara") {
      pdf.addImage(oneJumbo, "PNG", 50, y + 3, imageWidthImg - 3, imageHeightImg - 3);
      pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 20); // (x, y)
    } else {
      pdf.addImage(signature_sakon, "PNG", 50, y + 3, imageWidthImg - 3, imageHeightImg - 3);
      pdf.text("(นายสกล พัดริม)", 50, y + 20); // (x, y)
    }
    pdf.text("ทนายความประจำบริษัทฯ", 45, y + 24); // (x, y)
    pdf.text("ผู้รับมอบอำนาจ", 50, y + 29); // (x, y)
    pdf.text(`ขอแสดงความนับถือ`, 145, y + 2); // (x, y)
    pdf.addImage(oneBell, "PNG", 145, y + 3, imageWidthImg, imageHeightImg);

    pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 20); // (x, y)
    pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 24); // (x, y)
    pdf.text("ผู้ออกจดหมาย", 150, y + 29); // (x, y)
    pdf.setFont("THSarabunNew", "bold");
    pdf.text(
      `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.datetime)
        .add(543, "year")
        .format(
          "D MMMM YYYY",
        )} หากมาชำระหลังจากนี้ยอดเงินอาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
      15,
      y + 40,
    );
    pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 45); // (x, y)
  });

  // // เพิ่มหน้าใหม่
  // pdf.addPage();

  // // ตั้งค่าฟอนต์
  // pdf.setFont("THSarabunNew", "normal");
  // pdf.setFontSize(16);

  // // config layout
  // let finalYLeft = 20;
  // let finalYRight = 20;
  // let leftX = 10;
  // let rightX = 115; // จุดเริ่มคอลัมน์ขวา
  // let rowHeight = 30; // ความสูงต่อคน
  // let count = 0;
  // let columnCount = 0;

  // data.forEach((person, index) => {
  //   const x = count % 2 === 0 ? leftX : rightX;
  //   let y = count % 2 === 0 ? finalYLeft : finalYRight;

  //   // --- ชื่อ + ประเภท ---
  //   const nameType = `${person.customerFullname} (${person.customerTypeId === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.customerTypeId
  //     }) (${person.CONTNO})`;
  //   pdf.text(nameType, x, y);
  //   y += 6;

  // // --- ที่อยู่ บรรทัด 1 ---
  // if (person.ADDR1) {
  //   pdf.text(`เลขที่ ${person.ADDR1}`, x, y);
  //   y += 6;
  // }

  // // --- ที่อยู่ บรรทัด 2 ---
  // const addrLine2 = `ต.${person.TUMB} อ.${person.AUMPDES} จ.${person.PROVDES}`;
  // pdf.text(addrLine2, x, y);
  // y += 6;

  // --- ZIP ---
  // pdf.text(person.ZIP || "", x, y);

  // --- อัปเดต Y ตามคอลัมน์ ---
  // if (count % 2 === 0) {
  //   finalYLeft += rowHeight;
  // } else {
  //   finalYRight += rowHeight;
  //   columnCount++;
  // }

  // count++;

  // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
  // if (columnCount > 8) {
  //   columnCount = 0;
  //   console.log(" columnCount 0", columnCount);
  //   pdf.addPage();
  //   pdf.setFont("THSarabunNew", "normal");
  //   pdf.setFontSize(16);
  //   finalYLeft = 20;
  //   finalYRight = 20;
  // }
  // });

  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  // window.open(pdfUrl);
  return pdfUrl;
}
